import {RenderImage} from "../common/expansion/RenderImage";

export class GrayTileComponent {
    readonly active = 'active';
    private readonly grayTileImages: HTMLElement[];

    constructor(
        private container: HTMLElement
    ) {
        this.grayTileImages
            = Array.prototype.slice.call(this.container.querySelectorAll('[data-gray-tile-img]'));
    }
    public initialize(): void {
        RenderImage.loadImageSettingsCheck(this.container, this.grayTileImages)
    }
}
